define('responsive-gameday/views/distributors/viewDistributors/ViewDistributorBase',['require','exports','module','es6ish-class/es6ish-class','message-service/message-service'],function(require,exports,module) {
	var Classifier = require("es6ish-class/es6ish-class"),
		MessageService = require("message-service/message-service");

	function ViewDistributorBase(evt) {
		this.game = { };
		this.dataPack = { };
		this.eventType = evt || "";
	}

	ViewDistributorBase.prototype = {
		refresh: function(data) {
			this.game = data;
			this.prepDataForView();
		},

		prepDataForView: function(data) {
			// this function will be custom for every distributor
			return this.dataPack;
		},

		dispatchUpdates: function() {
			MessageService.publish(this.eventType, this.dataPack);
		},

		handleUpdateRequest: function() {
			this.dispatchUpdates();
		}
	};

	Classifier(ViewDistributorBase);
	return ViewDistributorBase;
});
